export default {
  // 获取url参数
  getUrlData(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    var pair;

    for (let i = 0; i < vars.length; i++) {
      pair = vars[i].split("=");

      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  },

  // 修改url所带参数
  replaceParamVal(url, arg, arg_val) {
    var pattern = arg + "=([^&]*)";
    var replaceText = arg + "=" + arg_val;
    var tmp;

    if (url.match(pattern)) {
      tmp = "/(" + arg + "=)([^&]*)/gi";

      tmp = url.replace(eval(tmp), replaceText);
      return tmp;
    }
    if (url.match("[?]")) {
      return url + "&" + replaceText;
    }
    return url + "?" + replaceText;
  },

  // 判断url后是否带某个参数
  getQueryString(name) {
    var reg = eval("/" + name + "/g");
    var r = window.location.search.substr(1);
    var flag = reg.test(r);
    if (flag) {
      return true;
    } else {
      return false;
    }
  },

  // 给url添加参数
  addOrgToUrl(url, paramName, replaceWith) {
    //url字符串添加参数
    //url:路径地址 paramName：参数名 replaceWith：参数值
    if (url.indexOf(paramName) > -1) {
      var re = eval("/(" + paramName + "=)([^&]*)/gi");
      url = url.replace(re, paramName + "=" + replaceWith);
    } else {
      var paraStr = paramName + "=" + replaceWith;

      var idx = url.indexOf("?");
      if (idx < 0) url += "?";
      else if (idx >= 0 && idx != url.length - 1) url += "&";
      url = url + paraStr;
    }
    return url;
  },

  // 格式化@符号和话题函数
  cotentReg(field) {
    var reg = /#[a-zA-Z0-9，。？！、：；“”＆%~*\u3130-\u9fa5]{1,20}/;
    var reg1 = /@[a-zA-Z0-9\-_\u3130-\u318f\uac00-\ud7a3\u2e80-\u9fff]+/g;
    var new_field;
    var str = field.match(reg);
    var str1 = field.match(reg1);

    if (str1) {
      str1.forEach(item1 => {
        field = field.replace(
          eval("/" + item1 + "/g"),
          `<span style="color:cornflowerblue">${item1}</span>`
        );
      });
    }

    if (str) {
      field = field.replace(
        eval("/" + str[0] + "/g"),
        `<span style="color:cornflowerblue">${str}</span>`
      );
    }
    field = field.replace(/[\n]/g, "<br/>");
    new_field = field;
    return new_field;
  }
};
